<template>
  <div class="content">
    <div v-if="load" class="loading"><img src="../assets/img/loading.gif" /></div>
    <div class="head">
      <div class="container">
        <div class="row">
          <div class="logo">
            <h2>先生用</h2>
          </div>
        </div>
        <div class="row keyMark">
          <img alt="" src="../assets/img/key.svg" />
        </div>
      </div>
    </div>

    <div class="login">
      <div class="container">
        <div class="row">
          <div @click="inputStNum" class="columns button">
            新しいクラスを作成する
          </div>
          <div @click="startClass" class="columns button">
            コードを入力する
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="pass" v-if="st">
        <p>クラスの人数を入力してください</p>
        <form @submit.prevent="createClass">
          <input type="number" v-model="stNum">
          <div v-if="errNum">
            "人数は1～50の間の整数で設定してください"
          </div>
          <div>
            <button v-bind:disabled="disabled"  type="button" @click="createClass" class="submitButton">OK</button>
            <button type="button" @click="classCancel">Cancel</button>
          </div>
        </form>
      </div>
    </transition>

    <transition name="fade">
      <div class="pass" v-if="passInput">
        <p>クラスコードを入力してください</p>
        <form @submit.prevent="loginT">
          <input type="number" v-model="pass">
          <div v-if="err">
            "クラスコードが違います"
          </div>
          <div>
            <button type="button" @click="loginT" class="submitButton">OK</button>
            <button type="button" @click="passCancel">Cancel</button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'adminLogin',
  data() {
    return{
      disabled: false,
      st: false,
      passInput: false,
      stNum: 0,
      pass: 0,
      err: false,
      errNum: false,
      load: false,
    };
  },
  methods:{
    inputStNum: function(){
      this.st = true;
    },
    createClass: function(){
      var self = this;
      if(!self.disabled){
        self.disabled = true;
        if(0<self.stNum && self.stNum<51){
          var param = {stNum: this.stNum};
          self.load = true;
          axios.post(self.$store.state.APIbase + 'api/classCreate', param)
          .then((res) => {
            console.log(res.data);
            self.err = false;
            self.$store.state.loggedIn = true;
            this.$store.state.classNum = res.data;
            self.$router.push({ name: 'teacherAd', params: { classNum:res.data } });
          })
        }else{
          self.errNum = true;
          setTimeout(function(){self.disabled = false; self.load = false}, 3000)
        }  
      }
    },
    classCancel: function(){
      this.st = false;
    },
    startClass: function(){
      this.passInput = true;
    },
    loginT: function(){
      var self = this;
      axios.get(self.$store.state.APIbase + 'api/auth/' + self.pass)
        .then((res) => {
          if(res.data.length){
            self.err = false;
            self.$store.state.loggedIn = true;
            if(res.data[0].stNum == 0){
              this.$router.push({ name: 'admin' });
            }else{
              this.$store.state.classNum = res.data[0].classNum;
              this.$router.push({ name: 'teacherAd', params: { classNum:res.data[0].classNum } });
            }
          }else{
            self.err = true;
            console.log(self.selectClass);
          }
        });
    },
    passCancel:function(){
      this.selectClass = 0;
      this.passInput = false;
    },
  }
}
</script>

<style scoped>
.content{
  min-height: 100vh;
  background:#effffb;
}
.head{
  width: 100%;
  height: 150px;
  min-height: 30px;
  background: #9cdee0;
  text-align: center;
}
.row{
  text-align: center;
}
.logo{
  padding-top: 40px;
  color: white;
  height: calc(100% - 130px);
}
.keyMark{
  width: 100px;
  background: white;
  border-radius: 50%;
  position: relative;
  left: calc(50% - 60px);
  bottom: -10px;
  text-align: center;
  padding: 10px;
  padding-left: 20px;
  padding-bottom: 30px;
  background: #effffb;
  box-shadow: 0px -4px 2px rgba(0,0,0,.5);
}
.keyMark img{
  width: 80px;
}
.login{
  padding-top: 70px;
  background: #effffb;
  box-shadow: 0px -4px 2px rgba(0,0,0,.5);
  text-align: center;
}
.button{
  padding-top: 10px;
  padding-bottom: 40px;
  transition: all .3s;
}
@media (min-width: 700px) {
  .button{
    margin-left: 0;
    margin-right: 3%;
  }
}
.button:hover{
  transform: scale(1.1);
}
.button:active{
  transform: scale(.9);
}

.pass{
  position: fixed;
  top: 10%;
  width: 90%;
  margin-left: 5%;
  padding: 5px;
  background: #effffb;
  border: solid 2px #299599;
  text-align: center;
  transition: all 1.2s;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.submitButton{
  background: #86cacc;
}

.loading{
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 999;
  background: rgba(0,0,0,.5);
}
.loading img{
  width: 40%;
  position: relative;
  top: 20px;
  left: 30%;
}
</style>
